import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "../dialog-header/dialog-header.component";

export type ConfirmDialogResult = true | false | "no";

@Component({
  selector: "scheduler-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.css"],
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class ConfirmDialogComponent {
  dialogRef =
    inject<MatDialogRef<ConfirmDialogComponent, ConfirmDialogResult>>(
      MatDialogRef
    );
  data = inject(MAT_DIALOG_DATA);

  title: string;
  message: string;
  messages: string[];
  showCancelButton: boolean = true;
  buttonMode: "ok-cancel" | "yes-no" | "yes-no-cancel" = "ok-cancel";

  constructor() {
    const data = this.data;

    // Receive data from the parent component
    this.message = data.message || "Are you sure?";
    this.title = data.title || "Confirmation";
    this.messages = data.messages || null;
    if (data.showCancelButton !== undefined) {
      this.showCancelButton = data.showCancelButton;
    }
    // Set button mode - defaults to 'ok-cancel' for backward compatibility
    this.buttonMode = data.buttonMode || "ok-cancel";
  }

  onConfirm(): void {
    // Close the dialog and return true
    this.dialogRef.close(true);
  }

  onNo(): void {
    // Close the dialog and return 'no' (distinct from dismiss/cancel)
    this.dialogRef.close("no");
  }

  onDismiss(): void {
    // Close the dialog and return false
    this.dialogRef.close(false);
  }
}
